// Sharing a result. The share sheet where the browser has one, the clipboard otherwise, and a
// toast with the link when even that is refused, so the action never dead-ends.

import * as toast from "../legacy/toast.js";
import { event } from "./track.ts";

export async function challenge(accuracy: number, line: { slug: string; name: string }): Promise<void> {
    const url = `${window.location.origin}/openings/${line.slug}`;
    const text = `I scored ${Math.round(accuracy)}% on the ${line.name} at Sparring Chess. Can you beat it?`;
    event("challenge_shared", { line: line.slug });

    if (navigator.share) {
        try {
            await navigator.share({ title: "Sparring Chess", text, url });
            return;
        } catch (err) {
            if ((err as Error).name === "AbortError") return;   // the share sheet was closed
        }
    }
    try {
        await navigator.clipboard.writeText(`${text} ${url}`);
        toast.showToast({ title: "Copied", message: "Paste it wherever your friends are.", type: "success", duration: 4000 });
    } catch {
        toast.showToast({ title: "Share this link", message: url, type: "info", duration: 10000 });
    }
}
